import script from "./NCPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NCPage.vue?vue&type=script&setup=true&lang=js"

import "./NCPage.vue?vue&type=style&index=0&id=418877d7&lang=css"
import "./NCPage.vue?vue&type=style&index=1&id=418877d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418877d7"]])

export default __exports__